// Dubai - female personal trainer. No trainer list (none in Dubai yet).
const content = {
    slug: 'female-personal-trainer',
    title: 'Female Personal Trainer in Dubai | Ladies-Only Home Sessions',
    description: (c) =>
        `Female personal trainers in Dubai for ladies-only sessions at home, in your building gym or villa. Packages from ${c.money(c.lowest + c.mods.female, 0)} a session.`,
    eyebrow: 'Dubai · Female trainer',
    h1: 'Female Personal Trainer in Dubai',
    lead: 'For many women in Dubai, training with a female coach at home is the only setup that feels right - private, comfortable, and on your schedule. Tell us your goal and preferences and we match you with a female trainer.',
    image: 'personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg',
    imageAlt: 'Female personal trainer coaching a woman through a workout',
    facts: ['Female trainers only', 'At home or in a ladies\' gym', 'Modest-friendly sessions'],
    ctaLabel: 'Request a female trainer',
    matchSummary: 'a female personal trainer in Dubai',
    packagesTitle: 'Packages with a female trainer',
    packagesHighlight: (c) => `Female trainer sessions cost ${c.money(c.mods.female, 0)} more per session than the listed price - for example ${c.money(c.pt('Signature', 30) + c.mods.female, 0)} a session on the 30-session Signature package.`,
    sections: [
        {
            title: 'Why women in Dubai choose a female trainer',
            cards: [
                { title: 'Privacy', body: 'Training at home without a male visitor, whether for personal, family or cultural reasons.' },
                { title: 'Comfort', body: 'Form corrections and hands-on cues feel easier with a female coach.' },
                { title: 'Women\'s health', body: 'Trainers who understand training around cycles, pregnancy, postpartum recovery and menopause.' },
            ],
        },
        {
            title: 'Where sessions happen',
            tone: 'muted',
            items: [
                'At home - living room, majlis or garden, with the trainer\'s own equipment.',
                'In ladies-only gym hours in your community or building.',
                'In a villa or compound gym.',
                'In small groups with sisters, friends or neighbours (partner pricing per person).',
            ],
        },
        {
            title: 'What to expect in your first session',
            paragraphs: [
                'Your trainer starts with a conversation about your goals, health history and any preferences - including what you are comfortable wearing and whether you prefer music, quiet or a certain time of day. Then a short movement check and a first workout scaled to you. You leave with a plan for the next four weeks.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Can I choose a female personal trainer in Dubai?',
            answer: 'Yes. Select a female trainer preference when you request a match.',
        },
        {
            question: 'Does a female trainer cost more?',
            answer: (c) => `Yes, by ${c.money(c.mods.female, 0)} a session, because female trainers are in high demand in Dubai.`,
        },
        {
            question: 'Can I train with my sister or a friend?',
            answer: 'Yes - choose partner training and each person pays about 70% of the solo price.',
        },
    ],
    schema: { name: 'Female Personal Trainer in Dubai' },
}

export default content
